import React from "react";
import {
  Variant,
  VariantOption,
} from "src/features/product-modal/model/Variant";
import getVariantStatus from "../../util/get-variant-status";
import { EnabledVariants } from "../../util/get-enabled-variants";
import { ProductModalErrors } from "../../model/ProductModalError";
import Responsive from "src/shared/components/Responsive";
import "./Variants.scss";

interface Props {
  enabledVariants: EnabledVariants;
  variants?: Variant[];
  toggleProductParams: (key: string, value: string) => void;
  isLoading: boolean;
  errors: ProductModalErrors;
}

const Variants = ({
  enabledVariants,
  variants,
  toggleProductParams,
  isLoading,
  errors,
}: Props) => {
  function setVariantOption(option: VariantOption, variantKey: string) {
    toggleProductParams(variantKey, option.value);
  }

  const [showColor, hasColorError, showSize, hasSizeError] = getVariantStatus(
    enabledVariants,
    errors
  );

  return (
    <>
      <Responsive
        desktop={() => import("./VariantsDesktop")}
        mobile={() => import("./VariantsMobile")}
      >
        {(Component: any) => (
          <Component
            showSize={showSize}
            showColor={showColor}
            hasColorError={hasColorError}
            hasSizeError={hasSizeError}
            isLoading={isLoading}
            enabledVariants={enabledVariants}
            variants={variants}
            setVariantOption={setVariantOption}
          />
        )}
      </Responsive>
    </>
  );
};

export default Variants;
